"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerBomMergeUploadUnusedReason = exports.CustomerBomMergeFailurePhase = void 0;
var CustomerBomMergeFailurePhase;
(function (CustomerBomMergeFailurePhase) {
    CustomerBomMergeFailurePhase["Merge"] = "merge";
    CustomerBomMergeFailurePhase["Enrichment"] = "enrichment";
})(CustomerBomMergeFailurePhase || (exports.CustomerBomMergeFailurePhase = CustomerBomMergeFailurePhase = {}));
var CustomerBomMergeUploadUnusedReason;
(function (CustomerBomMergeUploadUnusedReason) {
    CustomerBomMergeUploadUnusedReason["PackageHasDatasheet"] = "package_has_datasheet";
    CustomerBomMergeUploadUnusedReason["NoIdentity"] = "no_identity";
    CustomerBomMergeUploadUnusedReason["OwnershipConflict"] = "ownership_conflict";
    CustomerBomMergeUploadUnusedReason["DatasheetMissing"] = "datasheet_missing";
    CustomerBomMergeUploadUnusedReason["AnotherUploadChosen"] = "another_upload_chosen";
    CustomerBomMergeUploadUnusedReason["ManufacturerUnreadable"] = "manufacturer_unreadable";
})(CustomerBomMergeUploadUnusedReason || (exports.CustomerBomMergeUploadUnusedReason = CustomerBomMergeUploadUnusedReason = {}));
//# sourceMappingURL=customer-bom-merge-enums.js.map